const pageSelectToggleButton = document.querySelectorAll(".js-page-select-toggle");

if (
    typeof pageSelectToggleButton != "undefined" &&
    pageSelectToggleButton != null
) {
    const pageSelectOverlay = document.querySelector(".js-page-select"),
        pageSelectCloseSecondary = document.querySelector(".js-page-select-close"),
        pageSelectRows = document.querySelectorAll(".js-pg-select-row"),
        pageSelectRise = document.querySelectorAll(".js-pg-select-rise"),
        stopScrollingClass = "overlay-scroll",
        isActiveClass = "is-active";
    let isActive = false;

    //setup timeline
    const openPageSelectTl = gsap.timeline({ paused: true });
    openPageSelectTl
        .to(pageSelectOverlay, 0.3, { autoAlpha: 1, ease: Power1.easeInOut })
        .to(pageSelectRows, 0.4, { autoAlpha: 1, ease: Power1.easeInOut }, "-=0.2")
        .to(pageSelectRise, 0.5, { top: 0, autoAlpha: 1, ease: Power4.easeOut },"-=0.4");

    pageSelectToggleButton.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();

            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass);
                openPageSelectTl.pause();
                openPageSelectTl.restart();
                pageSelectOverlay.classList.add(isActiveClass);
                btn.classList.add(isActiveClass);
                btn.textContent = "close";
            } else {
                openPageSelectTl.pause();
                openPageSelectTl.reverse();
                body.classList.remove(stopScrollingClass);
                pageSelectOverlay.classList.remove(isActiveClass);
                btn.classList.remove(isActiveClass);
                btn.textContent = "Select Page";
            }
        });
    });

    pageSelectCloseSecondary.addEventListener("click", (e) => {
        e.preventDefault();

        openPageSelectTl.pause();
        openPageSelectTl.reverse();
        body.classList.remove(stopScrollingClass);
        pageSelectOverlay.classList.remove(isActiveClass);
        pageSelectToggleButton.forEach((btn) => {
            btn.classList.remove(isActiveClass);
            btn.textContent = "Select Page";
        });
        isActive = false;
    });
}
